<template>
  <div class="JoinUsDetail">
    <RouteHeadAndCrumbs
      :backgroundImg="backgroundImg"
      :breadcrumbsInfo="breadcrumbsInfo"
    />
    <div class="join-detail-container">
      <p class="join-detail-title">{{ joinInfo.title }}</p>
      <p class="content-desc" style="color:rgb(252,112,62);font-size:24px">薪资范围：{{ joinInfo.salary }}</p>
      <p class="content-desc" >反馈邮箱：{{ joinInfo.mailbox }}</p>
      <div
        v-html="joinInfo.content"
        class="join-detail-content-container"
      ></div>
    </div>
  </div>
</template>

<script>
import headImg from "../assets/images/joinUs.png";

import { ROUTEINFO } from "../utils/constant";

import { QUERY_JOIN_BY_ID } from "../utils/uriList";

export default {
  mounted() {
    this.getJoinInfoById();
  },
  data() {
    return {
      backgroundImg: headImg,
      breadcrumbsInfo: [
        {
          routeName: ROUTEINFO.home.name,
          routeLabel: "首页",
          routeTo: {
            path: ROUTEINFO.home.path,
          },
        },
        {
          routeName: ROUTEINFO.joinUs.name,
          routeLabel: "加入我们",
          routeTo: {
            path: ROUTEINFO.joinUs.path,
          },
        },
        {
          routeName: ROUTEINFO.joinUsDetail.name,
          routeLabel: "招聘详情",
        },
      ],
      joinInfo: {},
    };
  },
  methods: {
    async getJoinInfoById() {
      const response = await this.$http.get(QUERY_JOIN_BY_ID, {
        params: {
          id: this.$route.params.joinId,
        },
      });
      if (response.data.code === 0) {
        this.joinInfo = response.data.data;
      }
    },
  },
};
</script>

<style lang="scss">
@import "../assets/scss/views/JoinUsDetail.scss";
</style>
